import React from "react";
import { useInView } from 'react-intersection-observer';

import ComponentTitle from "../../../components/ComponentTitle/ComponentTitle";
import ServiceItem from "../../../components/ServiceItem";

import {
  StyledContainer,
  StyledTitleContainer,
  StyledInnerContainer,
} from "./ServiceDetailsStyles";

const ServiceDetails = ({ data }) => {
  const { ref, inView } = useInView({ triggerOnce: true });

  return (
    <StyledContainer ref={ref}>
      <StyledTitleContainer>
        <ComponentTitle value={data.componentTitle} />
      </StyledTitleContainer>
      {inView && (
        <StyledInnerContainer>
          {data.services.map(service => (
            <ServiceItem
              key={service.id}
              componentNum={service.id}
              converted
              title={service.title}
              description={service.description}
            />
          ))}
        </StyledInnerContainer>
      )}
    </StyledContainer>
  )
};

export default ServiceDetails;
